import API from 'services/TAPS_API';
import { NDFL3_NOTIFICATION_ID } from '../../constants';

export default function get2ndflList(year = '2016', id, name) {
  return API.request({
    method: 'POST',
    url: `/notification/${NDFL3_NOTIFICATION_ID}/${year}/parse2ndfl`,
    data: { id, agent: name },
  });
}
